import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {LoggingService} from '@tymes4-shared';
import { HttpLoaderService } from '@tymes4-shared';
import { AppIdentificationModel, CustomerService } from '../../api';
import { first } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';



@Component({
    selector: 'app-visitor-verification-info',
    templateUrl: './visitor-verification-info.html',
    styleUrls: ['./visitor-verification-info.scss'],
    standalone: false
})
export class VisitorVerificationInfoComponent implements OnInit {
  

  constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
              public dialogRef:  MatDialogRef<VisitorVerificationInfoComponent>,
              private customerService: CustomerService, 
              private sanitizer: DomSanitizer) { }

  photoUrl: SafeUrl | null = null;
  loading = true;
  genderString: string | null;
  data: AppIdentificationModel | null = null;

  ngOnInit() {

    this.customerService
      .getLatestAppIdentification(this.passedData.customerId, this.passedData.eventId)
      .pipe(first())
      .subscribe(data => {
        
        this.loading = false;
        this.data = data;

        if (data.Gender !== null) {
          this.genderString = "DIALOGS.VISITOR_VERIFICATION_INFO.GENDERS.OTHER";
          if (data.Gender.toLowerCase() == "m") this.genderString = "DIALOGS.VISITOR_VERIFICATION_INFO.GENDERS.MALE";
          if (data.Gender.toLowerCase() == "f") this.genderString = "DIALOGS.VISITOR_VERIFICATION_INFO.GENDERS.FEMALE";
        }

          this.photoUrl = this.sanitizer.bypassSecurityTrustUrl(
            'data:image/jpeg;base64,' + this.data.ImageBase64
          );

      });

  }
  
  submit() {
    this.dialogRef.close();
  }


}
